import { IconProviderConfig } from './types';

export const defaultIconConfig: IconProviderConfig = {
  defaultSize: 'md',
  defaultColor: 'inherit',
  sizeMap: {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 24,
    xl: 32,
  },
  colorMap: {
    // Theme-aware: resolve to the current theme's ink colours
    primary: 'var(--color-primary)',
    secondary: 'var(--color-text-secondary)',
    success: 'var(--color-success)',
    warning: 'var(--color-warning)',
    error: 'var(--color-danger)',
    inherit: 'currentColor',
  },
};

// Current icon provider - change this to switch icon libraries
export const CURRENT_ICON_PROVIDER = 'lucide' as const;
